require('./aggregatorLoanView.scss');

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
const { withRouter } = require('react-router-dom');

import { AggregatorProductsGenericView } from '../aggregatorProductsGenericView/aggregatorProductsGenericView';

import { ContentBox } from 'commonsComponents/contentBox';
import { OKBoxTitle } from 'commonsComponents/OKBoxTitle';

import { getProductDetails, getTransactionsTink } from 'actions/aggregator/aggregatorData';

import { formatDate } from 'utilities/dateHelper';
import { getFormattedString } from 'utilities/currencyHelper';

import { CommercialAds } from 'components/commons/commercialAds/commercialAds';

import { OKHeaderSubPageDetails } from 'components/commons/OKHeaderSubPageDetails/OKHeaderSubPageDetails';
import { OKHeaderSubPageValue } from 'components/commons/OKHeaderSubPageValue/OKHeaderSubPageValue';

const { formatText } = require('core/i18n').i18n;
import { NOT_ALLOWED_TINK_AGGREGATOR } from 'constants/flagBasedFeatures';

class AggregatorLoanViewClass extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { history, product } = this.props;
    if (!product) {
      history.push('/myprofile/global/entities/loans-mortgages');
    }
  }

  getBreadcrumb = () => {
    const { product, isTinkAggregator } = this.props;

    const alias = !isTinkAggregator ? product.get('alias') : product.alias;

    return [
      {
        text: formatText('breadcrumb-global'),
        url: '/myprofile/global',
      },
      {
        text: formatText('breadcrumb-otherBanks'),
        url: '/myprofile/global/entities/loans-mortgages',
      },
      {
        text: alias,
      },
    ];
  };

  renderItem(label, value) {
    const newValue = value || '-';
    return (
      <div className="aggregator-loan-mortgage-view__content__item col-xs-6">
        <div className="aggregator-loan-mortgage-view__content__item__label">{label}</div>
        <div className="aggregator-loan-mortgage-view__content__item__value">{newValue}</div>
      </div>
    );
  }

  renderHeader = extra => {
    const { product, isTinkAggregator } = this.props;

    const value = !isTinkAggregator ? product.get('debt') : product.debt;

    return (
      <OKHeaderSubPageDetails>
        <OKHeaderSubPageValue
          textKey="aggregator-expenses"
          value={product && value}
          isAmountType={true}
        />
        {extra}
      </OKHeaderSubPageDetails>
    );
  };

  render() {
    const { product, bankImg, isTinkAggregator } = this.props;

    const title = !isTinkAggregator ? product.get('alias') : product.alias;
    const subproduct = !isTinkAggregator ? product.get('subproduct') : product.subproduct;
    const balance = !isTinkAggregator ? product.get('balance') : product.balance;
    const endDate = !isTinkAggregator ? product.get('endDate') : product.endDate;
    const beginDate = !isTinkAggregator ? product.get('beginDate') : product.beginDate;
    const account = !isTinkAggregator ? product.get('account') : product.account;
    const deductionDate = !isTinkAggregator ? product.get('deductionDate') : product.deductionDate;
    const deduction = !isTinkAggregator ? product.get('deduction') : product.deduction;
    const valueRate = !isTinkAggregator ? product.get('valueRate') : product.valueRate;

    return (
      <AggregatorProductsGenericView
        renderHeaderDetails={product && this.renderHeader}
        breadcrumb={this.getBreadcrumb()}
        title={title}
      >
        <div className="row">
          <div className="col-xs-9">
            <div className="aggregator-loan-mortgage-view">
              <ContentBox>
                <OKBoxTitle>
                  <div className="row">
                    <div className="aggregator-loan-mortgage-view__title col-xs-8">
                      {formatText(`aggregatorLoansMortgages-${subproduct}Information`)}
                    </div>
                    <div className="col-xs-4">
                      <img src={bankImg} />
                    </div>
                  </div>
                </OKBoxTitle>
                <div className="row">
                  <div className="col-xs-8">
                    <div className="aggregator-loan-mortgage-view__content">
                      <div className="row">
                        {this.renderItem(
                          formatText('aggregatorLoanView-balance'),
                          balance && getFormattedString(balance)
                        )}
                        {this.renderItem(
                          formatText('aggregatorLoanView-endDate'),
                          endDate && formatDate(endDate)
                        )}
                      </div>
                      <div className="row">
                        {this.renderItem(
                          formatText('aggregatorLoanView-beginDate'),
                          beginDate && formatDate(beginDate)
                        )}
                        {this.renderItem(formatText('aggregatorLoanView-account'), account)}
                      </div>
                      <div className="row">
                        {this.renderItem(
                          formatText('aggregatorLoanView-nextShareDate'),
                          deductionDate && formatDate(deductionDate)
                        )}
                        {this.renderItem(
                          formatText('aggregatorLoanView-nextShare'),
                          deduction && getFormattedString(deduction)
                        )}
                      </div>
                      <div className="row">
                        {this.renderItem(
                          formatText('aggregatorLoanView-interest'),
                          valueRate && `${valueRate}%`
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </ContentBox>
            </div>
          </div>
          <div className="col-xs-3">
            <CommercialAds path="global/entities" type="banner-a" />
          </div>
        </div>
      </AggregatorProductsGenericView>
    );
  }
}

AggregatorLoanViewClass.propTypes = {
  product: PropTypes.object,
  history: PropTypes.object.isRequired,
  bankImg: PropTypes.string,
  isTinkAggregator: PropTypes.bool,
};

const AggregatorLoanView = withRouter(connect(
  (state, ownProps) => {
    const isTinkAggregator = state.flagBasedFeatures.get(NOT_ALLOWED_TINK_AGGREGATOR);

    const aggDataTink = state.aggregatorData.toJS().data;
    const mappedProductsForLoansTink = () => {
      const products = Array.isArray(aggDataTink.products) && aggDataTink.products;
      const banks = Array.isArray(aggDataTink.banks) && aggDataTink.banks;
      const mappedProducts =
        products &&
        products.map(product => {
          return {
            id: product.id,
            bank: product.bank,
            bankImg: banks && banks.find(bank => bank.name === product.bank).imageUrl,
            alias: product.alias,
            subproduct: product.subproduct,
            balance: product.balance,
            endDate: product.endDate,
            beginDate: product.beginDate,
            account: product.account,
            deductionDate: product.deductionDate,
            deduction: product.deduction,
            valueRate: product.valueRate,
            debt: product.debt,
          };
        });
      return mappedProducts;
    };
    const productsListTink = mappedProductsForLoansTink();
    const productTink =
      productsListTink && productsListTink.find(product => product.id === ownProps.match.params.id);
    const bankImgTink = productTink && productTink.bankImg;

    const product = !isTinkAggregator
      ? state.aggregatorData.getIn(['data', 'products', ownProps.match.params.id])
      : productTink;
    const bankImg = !isTinkAggregator
      ? state.aggregatorData.getIn([
          'data',
          'banks',
          product && product.getIn(['bank']),
          'imageUrl',
        ])
      : bankImgTink;

    return {
      product,
      bankImg,
      isTinkAggregator,
    };
  },
  {
    getProductDetails,
    getTransactionsTink,
  }
)(AggregatorLoanViewClass));

export { AggregatorLoanView };
